import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { apiGetQuoteSignatureDocumentList } from '@jove-frontend/uikit';
export var useQuoteDocument = function useQuoteDocument() {
  var _useState = useState(false),
      quoteDocumentLoading = _useState[0],
      setQuoteDocumentLoading = _useState[1];

  var _useState2 = useState([]),
      quoteDocumentList = _useState2[0],
      setQuoteDocumentList = _useState2[1];
  /**
   * requestes
   */


  var requestQuoteDocumentList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
      var _yield$apiGetQuoteSig, _yield$apiGetQuoteSig2, res, list;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setQuoteDocumentLoading(true);
              _context.next = 3;
              return apiGetQuoteSignatureDocumentList({
                quote_id: config === null || config === void 0 ? void 0 : config.quoteId,
                source_type: (config === null || config === void 0 ? void 0 : config.sourceType) || 'quote'
              });

            case 3:
              _yield$apiGetQuoteSig = _context.sent;
              _yield$apiGetQuoteSig2 = _slicedToArray(_yield$apiGetQuoteSig, 1);
              res = _yield$apiGetQuoteSig2[0];
              setQuoteDocumentLoading(false);
              list = [];

              if (res) {
                list = (res.data || []).map(function (item) {
                  item.url = item.download_url;
                  item.language = '';
                  return item;
                });
                setQuoteDocumentList(list);
              }

              return _context.abrupt("return", list);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestQuoteDocumentList(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    requestQuoteDocumentList: requestQuoteDocumentList,
    quoteDocumentList: quoteDocumentList,
    quoteDocumentLoading: quoteDocumentLoading
  };
};